"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useUser } from "@auth0/nextjs-auth0/client";
import axios from "axios";
import Meta from "../../../components/Meta";
import prisma from "../../../prisma/prisma";
import EntityMappingService from "../../../services/entity-mapping-service";
import RaceCalendarListView from "../../../components/race-calendar/list-view";
import RaceCalendarMapView from "../../../components/race-calendar/map-view";
import { HeadLine } from "../../../components/component";
import { MdOutlineGridView, MdMap, MdRssFeed } from "react-icons/md";
import BannerAd from "../../../components/banner-ad";
import MailChimpPopup from "../../../components/newsletter/mail-chimp-popup";
import NowVurbmotoProspect from "../../../components/now-vurbmoto-prospect-section/now-vurbmoto-prospect-section";
const Index = ({
  featured
}) => {
  return <>
      <Meta title="Race Calendar || AmateurMoto.com | A national race calendar" data-sentry-element="Meta" data-sentry-source-file="index.jsx" />
      <NowVurbmotoProspect data-sentry-element="NowVurbmotoProspect" data-sentry-source-file="index.jsx" />
    </>;
};
export default Index;